import React from 'react'

export default function Error() {
  return (
    <div style={{marginTop:'150px'}}>Error!! Page Not Found!</div>
  )
}
